<template>
  <div id="cat" v-cloak>
    <div class="vx-card">
      <div class="vx-card__body card-body">
        <div class="vx-col sm:w-1/3 w-full mb-2">
          <vs-button @click.prevent="onShowCreatePopup()" class="bg_l_green">
            <feather-icon icon="PlusIcon" svgClasses="h-4 w-4" class="ico" />
            {{ $t("CreateNewCounting") }}
          </vs-button>
        </div>
        <div class="vx-row" v-if="loaded">
          <div class="vx-col w-full mb-base">
            <data-grid
              ref="grid"
              stripe
              :data-source="gridDataSource"
              :search-data="gridSearchData"
              :columns="[
                { title: $t('RepeatCounting') },
                { title: $t('ID') },
                { title: $t('Action') },
              ]"
            >
              <template slot-scope="{ row, index }">
                <td style="width: 30%">{{ $t("Counting") }} {{ index + 1 }}</td>
                <td style="width: 30%">
                  {{ row.id }}
                </td>
                <td style="width: 40%">
                  <div
                    class="flex gap-4 flex-wrap justify-center items-center w-full h-full"
                  >
                    <router-link
                      :to="{
                        path:
                          '/WarehouseHandling/CountingTag/Details/' + row.id,
                        query: {
                          breadcrumbNameManual: {
                            persianTitleParent: breadcrumbNameManualParent,
                            persianTitleChild: row.stockTakingId,
                          },
                        },
                      }"
                    >
                      <vs-button
                        color="success"
                        type="gradient"
                        icon-pack="feather"
                        v-if="!row.isCompleted"
                        >{{ $t("Groups") }}</vs-button
                      >
                    </router-link>
                    <vs-button
                      color="primary"
                      type="gradient"
                      icon-pack="feather"
                      v-if="!row.isCompleted"
                      @click.prevent="isEndCountingForAllGroup(row.id)"
                      >{{ $t("EndCounting") }}</vs-button
                    >
                    <vs-button
                      color="primary"
                      type="gradient"
                      icon-pack="feather"
                      @click.prevent="onFindDiscrepanct(row.id)"
                      v-if="row.isCompleted"
                      class="d-inline"
                      >{{ $t("DiscrepancyCheck") }}</vs-button
                    >

                    <vs-button
                      color="danger"
                      type="gradient"
                      icon-pack="feather"
                      @click.prevent="deleteCountingTag(row.id)"
                      v-if="row.isCompleted"
                      class="d-inline"
                      >{{ $t("ClearCounting") }}</vs-button
                    >
                    <vs-button
                      color="warning"
                      type="gradient"
                      icon-pack="feather"
                      v-if="row.isCompleted"
                      @click.prevent="onShowDiscrepancyPopup(row.id)"
                      class="d-inline"
                      >{{ $t("ShowDiscrepancy") }}</vs-button
                    >
                  </div>
                </td>
              </template>
            </data-grid>
          </div>
        </div>
        <show-discrepancy-popup
          :stockTakingId="stockTakingId"
          :countTagId="countTagId"
          :show="isDiscrepancyPopup"
          @finish="onfinish"
        ></show-discrepancy-popup>
      </div>
    </div>
  </div>
</template>

<script>
import "@/assets/scss/vuesax-rtl/pages/_custom.scss";
import DataGrid from "@/components/datagrid/DataGrid";
import ShowDiscrepancyPopup from "./CountingTag/ShowDiscrepancyPopup.vue";
import { mapActions } from "vuex";

export default {
  name: "warehouseManagement_WarehouseHandling_Index",
  components: {
    DataGrid,
    ShowDiscrepancyPopup,
  },
  data() {
    return {
      breadcrumbNameManualParent: "",
      countTagId: "",
      manualUrlService: "",
      stockTakingId: "",
      loaded: false,
      isDiscrepancyPopup: false,
      gridDataSource: { data: [] },
      gridSearchData: {},
      modelForFinish: {},
      modelForDiscrepanct: {},
      modelForCreateCountingTag: {},
    };
  },
  mounted() {
    this.stockTakingId = this.$route.params.id;
    this.manualUrlService =
      "Inventory/api/CountingTagQuery/stock-taking/" + this.stockTakingId;
    this.gridDataSource = { type: "app", service: this.manualUrlService };
    setTimeout(() => {
      this.loaded = true;
    }, 100);
    this.breadcrumbNameManualParent =
      this.$route.query.breadcrumbNameManual.persianTitleParent;
  },
  methods: {
    ...mapActions({
      removeCountingTag: "warehouseHandling/removeCountingTag",
      findDiscrepanct: "warehouseHandling/findDiscrepanct",
      createCountingTag: "warehouseHandling/createCountingTag",
      completeCounting: "warehouseHandling/completeCounting",
    }),
    onFindDiscrepanct(countTagId) {
      this.modelForDiscrepanct.countTagId = countTagId;
      this.findDiscrepanct(this.modelForDiscrepanct).then(() => {
        this.$swal({
          position: "center-center",
          type: "success",
          text: "مغایرت انجام شد!",
          showConfirmButton: false,
          timer: 2000,
        });
        this.$refs.grid.renderGrid();
      });
    },
    onfinish() {
      // this.isStartAndModifyPopup = false;
      this.isDiscrepancyPopup = false;
      this.$refs.grid.renderGrid();
    },
    onShowCreatePopup() {
      this.modelForCreateCountingTag.stockTakingId = this.stockTakingId;
      this.createCountingTag(this.modelForCreateCountingTag).then(() => {
        this.$refs.grid.renderGrid();
      });
    },
    isEndCountingForAllGroup(id) {
      this.$swal({
        title: "آیا از اتمام شمارش " + id + " برای تمام گروه‌ها اطمینان دارید؟",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "بلی",
        cancelButtonText: "خیر",
      }).then((result) => {
        if (result.value) {
          this.modelForFinish.countingTagId = id;
          this.completeCounting(this.modelForFinish).then(() => {
            this.$refs.grid.renderGrid();
          });
        }
      });
    },
    onShowDiscrepancyPopup(id) {
      this.countTagId = id;
      this.isDiscrepancyPopup = true;
    },
    deleteCountingTag(id) {
      this.$swal({
        title: "آیا از حذف این رکورد اطمینان دارید؟",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "بلی",
        cancelButtonText: "خیر",
      }).then((result) => {
        if (result.value) {
          this.removeCountingTag(id).then(() => {
            this.$swal({
              position: "center-center",
              type: "success",
              text: "رکورد مورد‌نظر با موفقیت حذف شد!",
              showConfirmButton: false,
              timer: 2000,
            });
            this.$refs.grid.renderGrid();
          });
        }
      });
    },
  },
};
</script>
